import React from 'react'
import { TextEditor } from 'components/TextEditor/TextEditor'

const DescriptionSection = ({ values, onEditorChange }) => {
  return (
    <TextEditor
      initialValue={values.about || ''}
      onChange={onEditorChange}
      placeholder='Enter Job Description'
    />
  )
}

export default DescriptionSection
